import { render, staticRenderFns } from "./RecipeCard.vue?vue&type=template&id=9d9be632&scoped=true"
import script from "./RecipeCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RecipeCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RecipeCard.vue?vue&type=style&index=0&id=9d9be632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9be632",
  null
  
)

export default component.exports